













































/* Created- 22 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { eParticaAction, getActionName, ParticaEvent } from "../Models/ParticaEvent";
import { ButtonConfig, ButtonType } from "../Models/Buttons";
import ParticaAccountBase from "./Base/ParticaAccountBase.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import ParticaList2Line from "@/Ui-Components/Common/List/ParticaList2LineV3.vue";
import { ParticaListContent, ParticaListLineContent } from "../Models/ParticaListModel";
import { WordpressPluginDTO, WordpressPluginDTOStatus } from "../Generated/ParticaAPI";
import ParticaRightDrawer from "@/Ui-Components/Common/Container/ParticaRightDrawer.vue";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import WordpressPluginForm from "@/Ui-Components/Plugins/WordpressPluginForm.vue";
import { IWordpressPluginService } from "../BusinessServices/wpplugin";

@Component(
	{
		name: "Plugins",
		components: {
			ParticaCard,
			ParticaView,
			ParticaList2Line,
			ParticaRightDrawer,
			ButtonList,
			WordpressPluginForm
		}
	})
export default class AccountPlugins extends ParticaAccountBase {
	@Prop() private id: number;
	private wpsites: ParticaListContent = new ParticaListContent();
	private wpdrawer: boolean = false;

	private wpbuttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.VIEW_WP_PLUGIN, label: "View wordpress plugin" } as ButtonConfig,
	];
	private wpoptions: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.ADD_WP_PLUGIN, label: "Add wordpress plugin", type: ButtonType.Normal } as ButtonConfig,
	];
	private wpformbuttons: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.SAVE_WP_PLUGIN, label: "Save Plugin", type: ButtonType.OK } as ButtonConfig,
		{ action: eParticaAction.DELETE_WP_PLUGIN, label: "Delete Plugin", type: ButtonType.Cancel } as ButtonConfig,
		{ action: eParticaAction.VIEW_WP_SITE, label: "View Wordpress Site", type: ButtonType.Normal } as ButtonConfig,
	];

	private wordpressService: IWordpressPluginService;
	private plugin: WordpressPluginDTO = new WordpressPluginDTO();

	private getWordpressLoginUrl(): string {
		return `${this.plugin.url}/wp-login.php?redirect_to=${this.plugin.url}/wp-admin/edit.php`;
	}

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.VIEW_WP_PLUGIN: {
					this.plugin = event.item.item as WordpressPluginDTO;
					this.wpdrawer = true;
					break;
				}
				case eParticaAction.SAVE_WP_PLUGIN: {
					this.plugin = await this.wordpressService.save(this.plugin);
					this.wpdrawer = false;
					await this.init();
					break;
				}
				case eParticaAction.ADD_WP_PLUGIN: {
					this.plugin.customerAccountId = this.id;
					this.plugin.id = 0;
					this.plugin.user = "";
					this.plugin.password = "";
					this.plugin.url = "";
					this.plugin.status = WordpressPluginDTOStatus.Draft;
					this.wpdrawer = true;
					break;
				}

				case eParticaAction.VIEW_WP_SITE: {
					this.$refs.wordpressform.submit();
					break;
				}

				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (error) {
			this.ShowErrorDialog(error, `Unhandled event. ${getActionName(event.action)}`);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.getAccountNav(this.id);
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Account Plugins";
		await this.getAccountNav(this.id);
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.wpsites.lines = [];
			this.wordpressService = this.particaServices.getWordpressPluginService();
			const tmp = await this.wordpressService.get(this.id);
			tmp.forEach(site => {
				this.wpsites.lines.push({ id: site.id, title: site.url, item: site, image: "", subtitle: site.user } as unknown as ParticaListLineContent);
			});
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured loading the content stream ${this.id}`
			);
		} finally {
			this.LoadingEnd();
		}
	}

	public $refs: {
		wordpressform: HTMLFormElement
	};

}
